export default __webpack_public_path__ + "static/2-e04c6b94d0bbe0589ef364ed3e620532.png";